export default __webpack_public_path__ + "static/media/cert-it-HKIRC.757943de.jpg";